export const ToolCategory = {
    'SCA':'SCA',
    'IAC': 'IaC',
    'SAST': 'SAST',
    'DAST': 'DAST',
    'MAST': 'MAST',
    'IAST': 'IAST',
    'CSPM':'CSPM',
    'VAPT': 'VAPT',
    'SBOM': 'SBOM',
    'SCM': 'SCM',
    'TPRM': 'TPRM',
    'PIA': 'PIA',
    'RASP': 'RASP',
    'LICENSE': 'License',
    'SECRETS': 'Secrets',
    'REPUTATION': 'Reputation',
    'BUG_BOUNTY':'Bug Bounty',
    'DATA_SECURITY': 'Data Security',  
    'API_FUZZING': 'API Fuzzing',
    'API_SECURITY': 'API Security',
    'CODE_INSIGHTS': 'Code Insights',
    'CONTAINER_SECURITY': 'Container Security',
    'INFRASTRUCTURE_TOOLS':'Infrastructure Tools',
    'THREAT_MODEL':'Threat Model',
    'THREAT_INTELLIGENCE':'Threat Intelligence',
    'AUTOMATION':'Automation',
    'VERSION_CONTROL': 'Version Control',
    'DYNAMIC':'Dynamic',
    'PENTESTING_FRAMEWORK':'Pentesting Framework',
    'MISCONFIGURATION': 'Misconfiguration',
    'EASM': 'External Attack Surface Management',
    'ENDPOINT_VULNERABILITES': 'Endpoint Vulnerability Management'
}